import { useEffect, useState } from 'react'

import { useAppSelector } from 'redux/hooks'

import MultiSelectControls from 'components/deckPage/modals/MultiSelectControls'
import HighlightedCardControls from 'components/deckPage/modals/HighlightedCardControls'
import FloatingMenuWrapper from 'components/misc/FloatingMenu/Wrapper'

import styles from './floatingMenu.module.scss'

type MenuType = 'multiSelect' | 'highlighted'

const FloatingMenu = () => {
  const [menuItems, setMenuItems] = useState<MenuType[]>([])
  const [visibleMenuItems, setVisibleMenuItems] = useState<MenuType[]>([])

  const highlightedCards = useAppSelector(state => state.active.highlightedCards)
  const multiSelectedIds = useAppSelector(state => state.active.multiSelectedIds)

  useEffect(() => {
    const actualMenuState: Record<MenuType, boolean> = {
      multiSelect: Object.keys(multiSelectedIds).length > 0,
      highlighted: Object.keys(highlightedCards).length > 0,
    }

    for (const menuType of Object.keys(actualMenuState)) {
      const type = menuType as MenuType

      const menuShouldBeOpen = actualMenuState[type]
      const menuIsInMenuArray = menuItems.indexOf(type) > -1

      // Enter
      if (menuShouldBeOpen && !menuIsInMenuArray) {
        setMenuItems([...menuItems, type])
        setTimeout(() => setVisibleMenuItems([...visibleMenuItems, type]), 250)
      }

      // Leaving
      if (!menuShouldBeOpen && menuIsInMenuArray) {
        setVisibleMenuItems(visibleMenuItems.filter(item => item !== type))
        setTimeout(() => setMenuItems(menuItems.filter(item => item !== type)), 250)
      }
    }
  }, [highlightedCards, multiSelectedIds])

  return (
    <div className={styles.container}>
      {menuItems.map(menuType => {
        const visabilityIndex = visibleMenuItems.findIndex(item => item === menuType)

        // Transitions offscreen when visabilityIndex is -1
        return (
          <FloatingMenuWrapper
            // Reversing the list to bump items up as new items come into the DOM
            level={visabilityIndex !== -1 ? visibleMenuItems.length - 1 - visabilityIndex : -1}
            nutralBorder={menuType === 'highlighted'}
            key={menuType}>
            {menuType === 'multiSelect' && <MultiSelectControls />}
            {menuType === 'highlighted' && <HighlightedCardControls />}
          </FloatingMenuWrapper>
        )
      })}
    </div>
  )
}

export default FloatingMenu
